import React, {ReactNode, useMemo} from 'react'
import {Modal as AntdModal, Divider, ModalProps} from 'antd'
import {KTSVG} from '../../../_metronic/helpers'

type Props = {
  props?: any
  children: ReactNode
  size?: 'sm' | 'lg' | 'xl' | 'xxl' | undefined
  title: string | ReactNode
  show?: boolean
  centered?: boolean
  onOk?: Function
  onCancel?: Function
  okLoading?: boolean
  cancelLoading?: boolean
  hideAction?: boolean
  okText?: string
  okDanger?: boolean
  maskClosable?: boolean
  className?: string
  modalProps?: ModalProps
}

const Modal: React.FC<Props> = (props) => {
  const {
    children,
    show = false,
    size = undefined,
    centered = false,
    hideAction = false,
    onCancel = () => {},
    cancelLoading = false,
    onOk = () => {},
    okText = 'Simpan',
    okLoading = false,
    maskClosable = true,
    className,
    modalProps,
  } = props

  const width = useMemo(() => {
    let _width = 600
    switch (size) {
      case 'lg':
        _width = 700
        break
      case 'xl':
        _width = 1000
        break
      case 'xxl':
        _width = 1300
        break
      case 'sm':
      default:
        break
    }
    return _width
  }, [size])

  return (
    <AntdModal
      centered={centered}
      {...modalProps}
      // size={size}
      // backdrop='static'
      keyboard={true}
      onCancel={() => onCancel()}
      closable={false}
      footer={null}
      open={show}
      rootClassName={className}
      width={width}
      maskClosable={maskClosable}
      title={
        <div className='mt-n2'>
          <div className='d-flex justify-content-between align-items-center'>
            <h3 className='fw-bold mb-0' style={{letterSpacing: -0.5}}>
              {props.title ?? ''}
            </h3>
            <div className='me-n4'>
              <div className='btn btn-icon btn-sm btn-active-light-primary' onClick={() => onCancel()}>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
              </div>
            </div>
          </div>
          <Divider className='ms-n7 me-n7 mb-3 mt-3' style={{width: 'auto'}} />
        </div>
      }
    >
      {children}
      {!hideAction && (
        <div className='marvel-modal-footer text-end'>
          <Divider className='mx-n7 mt-9 mb-4' style={{width: 'auto'}} />
          <div className=''>
            <button type='button' className='btn btn-primary btn-sm fs-6 px-7' disabled={okLoading} onClick={async () => onOk()}>
              {!okLoading && okText}
              {okLoading && (
                <span className='indicator-progress fs-6' style={{display: 'block'}}>
                  Silahkan tunggu... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
            <button type='button' title='Add new Specification' className='btn btn-light btn-sm fs-6 px-7 ms-2' disabled={okLoading || cancelLoading} onClick={() => onCancel()}>
              Batal
            </button>
          </div>
        </div>
      )}
    </AntdModal>
  )
}

export default Modal
